import p4_img from "./shose_women/p4.jpg";
import p24_img from "./shoes_kids/p24.jpg";
import p16_img from "./shose_man/p16.jpg";
import p6_img from "./shose_women/p6.jpg";
import p15_img from "./shose_man/p15.jpg";
import p8_img from "./shose_women/p8.jpg";
import p13_img from "./shose_man/p13.jpg";
import p20_img from "./shoes_kids/p20.jpg";

let new_collections = [
  {
    id: 4,
    name: "ELITE SPORT PRO- RADIANT SQUA",
    category: "women",
    image: p4_img,
    new_price: 999.0,
    old_price: 1599.0,
    discriptions: "Athletic style and awesome comfort combine in Skechers Elite Sport - Radiant Squads. This lace-up features an engineered mesh upper with synthetic hotmelt detail, cushione",
  },
  {
    id: 24,
    name: "SKECH POPS BLAST",
    category: "men",
    image: p24_img,
    new_price: 1399.0,
    old_price: 1699.0,
    discriptions: "Poppable fun combines with awesome comfort in the Skechers Skech Pops Blast. This pop bubble themed sneaker features mesh and synthetic upper with stretch laces and a cushioned insole.",
  },
  {
    id: 16,
    name: "UPPER CUT CLASSIC JOGGER-ASH",
    category: "men",
    image: p16_img,
    new_price: 2999.0,
    old_price: 3599.0,
    discriptions: "Kick it old school with a fresh look in Mark Nason Los Angles Upper Cut Classic Jogger - Ash. This lace-up sneaker features a soft suede and nylon fabric upper with a cushi",
  },
  {
    id: 6,
    name: "RELAXED FIT- D'LUX FITNESS",
    category: "women",
    image: p6_img,
    new_price: 2229.0,
    old_price: 2590.0,
    discriptions: "Stay motivated in well-cushioned comfort during your workouts with Skechers Relaxed Fit® D'Lux Fitness. This lace-up features an engineered mesh upper with a cushioned Skech",
  },
  {
    id: 15,
    name: "UNO - STAND ON AIR",
    category: "men",
    image: p15_img,
    new_price: 2209.0,
    old_price: 2799.0,
    discriptions: "This lace-up fashion sneaker features a smooth perforated synthetic upper with an Air-Cooled Memory Foam® insole and Skech-Air® visible air-cushioned midsole",
  },
  {
    id: 8,
    name: "ULTRA FLEX 3",
    category: "women",
    image: p8_img,
    new_price: 1509.0,
    old_price: 2029.0,
    discriptions: "Step out in colorful style and comfort wearing Skechers Ultra Flex 3.0. This Stretch Fit design features a Skech-Knit upper with multicolor gore straps and a cushioned Skechers Air",
  },
  {
    id: 13,
    name: "UNO - POWEX",
    category: "men",
    image: p13_img,
    new_price: 2509.0,
    old_price: 2999.0,
    discriptions: "Classic air cushioned style meets updated comfort in the SKECHERS Uno – Powex shoe. Synthetic and textile upper in a lace up classic jogger style sneaker with stitching and perforation acc",
  },
  {
    id: 20,
    name: "RAZOR FLEX AIR",
    category: "men",
    image: p20_img,
    new_price: 1009.0,
    old_price: 1359.0,
    discriptions: "A sporty style that keeps up with his every move comes in the Skechers Razor Flex AIR - shoe. This lightweight Gore & Strap Sneaker with Lateral Tech Piece and mesh upper with an Ai",
  },
];

export default new_collections;
